// Default site ID for operations.
// NEXT_PUBLIC_* env vars are automatically inlined by Next.js at build time
const DEFAULT_SITE_ID = process.env.NEXT_PUBLIC_DEFAULT_SITE_ID || ''

const DIRECT_PROXY_ENDPOINTS = new Set(['/agent/login', '/agent/verify'])

const DIRECT_PROXY_SEGMENTS = new Set([
  'announcements',
  'auth',
  'csv', // CSV download endpoints for table data exports
  'documents',
  'email',
  'news',
  'search',
  'sites',
  'healthcare', // ensure healthcare calls use direct /api prefix (embed needs unauth public endpoints)
])

export { DEFAULT_SITE_ID, DIRECT_PROXY_ENDPOINTS, DIRECT_PROXY_SEGMENTS }

export const resolveDefaultSiteId = (): string => {
  if (!DEFAULT_SITE_ID || DEFAULT_SITE_ID.trim() === '') {
    throw new Error('DEFAULT_SITE_ID is not defined')
  }
  return DEFAULT_SITE_ID
}

export const ensureLeadingSlash = (path: string): string =>
  path.startsWith('/') ? path : `/${path}`

export const shouldUseDirectNextProxy = (rawEndpoint: string): boolean => {
  const endpoint = ensureLeadingSlash(rawEndpoint)
  if (DIRECT_PROXY_ENDPOINTS.has(endpoint)) {
    return true
  }
  const segment = endpoint.split('/')[1] ?? ''
  return DIRECT_PROXY_SEGMENTS.has(segment)
}
